// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import * as echarts from 'echarts'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css' // a modern alternative to CSS resets

import '@/styles/index.scss' // global css

//  引入element-ui
import ElementUI from 'element-ui'
import './styles/element-variables.scss'
import 'element-ui/lib/theme-chalk/index.css'
import lang from 'element-ui/lib/locale/lang/en' // 英文
import locale from 'element-ui/lib/locale'
import less from 'less'

import baseurl from './api/basepath'
import Axios from 'axios'
import VueAxios from 'vue-axios'
import Moment from 'moment' // 时间格式化插件

import App from './App'
import store from './store'
import router from './router'
import 'jquery'
import './permission' // permission control

// 引入svg组件
import SvgIcon from '@/components/SvgIcon'
import '@/icons/index.js'

// 引入Linechart图自定义组件
import Linechart from '@/components/LineChart'

// 引入WebGL自定义组件
import WebGLView from '@/components/WebGLView'

// 引入ThreeJSView自定义组件
import ThreeJSView from '@/components/ThreeJSView'

// 引入谷歌浏览器检测机制
// import 'default-passive-events'

// 引入mockjs
require('../src/api/mock')

locale.use(lang)

Vue.use(ElementUI, {
  size: Cookies.get('size') || 'medium' // set element-ui default size
})
Vue.use(less)

Vue.prototype.$echarts = echarts
Vue.prototype.$Moment = Moment

Vue.prototype.api = baseurl
Vue.prototype.$axios = Axios
Vue.use(VueAxios, Axios)

// 全局注册icon-svg
Vue.component('svg-icon', SvgIcon)
// 全局注册其他组件
Vue.component('my-linechart', Linechart)
Vue.component('my-webglview', WebGLView)
Vue.component('my-threejsview', ThreeJSView)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js